export default "<r-card-onboarding\n  #onboardingViews\n  (errorAction)=\"errorAction()\"\n  (continueAction)=\"continueAction()\"\n></r-card-onboarding>\n";